import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import SubAbasInformes from './subabasInformes';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useAlcanceInforme } from '../../../../services/enum/useAlcanceInforme';
import { useImagemCard } from '../../../../services/enum/useImagemCard';
import { useStatusDisplayInforme } from '../../../../services/enum/useStatusDisplayInforme';
import { getInforme } from '../../../../services/gestaoSisAF/informesSisafService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { formataNomeMeioSiglas } from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
} from '../../../../utils/swal';

export default function InformeFicha() {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;

  const params = useParams();
  const fichaID = String(params.id);
  const navigate = useNavigate();

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const statusDisplay = useStatusDisplayInforme();
  const imagemCard = useImagemCard();
  const alcanceInforme = useAlcanceInforme();

  const alcanceBin = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'Sim' },
    { value: 2, label: 'Não' },
  ];

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formMain, setFormMain] = useState({
    usuarioId: userID,
    alcanceDaf: '',
    statusDisplay: '',
    imagemCard: '',
    dataInforme: '',
    titulo: '',
    resumo: '',
    descricao: '',
    urlMaisInfor: '',
    alcanceFornecedor: '',
    alcanceSes: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getInforme(id);
      setLogData(registroData);

      const dataInforme = registroData.dataInforme
        ? new Date(registroData.dataInforme).toISOString().split('T')[0]
        : '';

      const alcanceFornecedorNumber =
        registroData.alcanceFornecedor === 'S' ? '1' : '2';

      const alcanceSesNumber = registroData.alcanceSes === 'S' ? '1' : '2';

      setFormMain({
        usuarioId: userID,
        alcanceDaf: registroData.alcanceDaf,
        statusDisplay: registroData.statusDisplay,
        imagemCard: registroData.imagemCard,
        dataInforme: dataInforme,
        titulo: registroData.titulo,
        resumo: registroData.resumo,
        descricao: registroData.descricao,
        urlMaisInfor: registroData.urlMaisInfor,
        alcanceFornecedor: alcanceFornecedorNumber,
        alcanceSes: alcanceSesNumber,
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //
  const [statusDisplayStyle, setStatusDisplayStyle] =
    useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';

    const status = formMain.statusDisplay;

    const newStatus = {
      backgroundColor:
        status === '' ? 'white' : status == '1' ? verde : vermelho,
    };

    setStatusDisplayStyle(newStatus);
  }, [formMain.statusDisplay]);

  const [alcanceFornecedorStyle, SetAlcanceFornecedorStyle] =
    useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';

    const alcance = formMain.alcanceFornecedor;

    const newAlcance = {
      backgroundColor:
        alcance === '' ? 'white' : alcance == '1' ? verde : vermelho,
    };

    SetAlcanceFornecedorStyle(newAlcance);
  }, [formMain.alcanceFornecedor]);

  const [alcanceSesStyle, SetAlcanceSesStyle] = useState<React.CSSProperties>(
    {},
  );
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';

    const alcance = formMain.alcanceSes;

    const newAlcance = {
      backgroundColor:
        alcance === '' ? 'white' : alcance == '1' ? verde : vermelho,
    };

    SetAlcanceSesStyle(newAlcance);
  }, [formMain.alcanceSes]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasInformes(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/adm/informes/ficha/dadosgerais`,
      },
    ];
  }

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    setFormMain((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.alcanceDaf) {
      errors.push('<b>Alcance DAF</b> é obrigatório.');
    }

    if (!form.statusDisplay) {
      errors.push('<b>Status</b> é obrigatório.');
    }

    if (!form.imagemCard) {
      errors.push('<b>Imagem do Card</b> é obrigatório.');
    }

    if (!form.dataInforme) {
      errors.push('<b>Data do informe</b> é obrigatório.');
    }

    if (!form.titulo) {
      errors.push('<b>Título</b> é obrigatório.');
    }

    if (!form.resumo) {
      errors.push('<b>Resumo</b> é obrigatório.');
    }

    if (!form.descricao) {
      errors.push('<b>Descrição</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalErro(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formMain);
      if (!isFormValid) return;

      const formToSend = {
        ...formMain,
        alcanceDaf: Number(formMain.alcanceDaf),
        statusDisplay: Number(formMain.statusDisplay),
        imagemCard: Number(formMain.imagemCard),
        dataInforme: formMain.dataInforme ? formMain.dataInforme : null,
        alcanceFornecedor: formMain.alcanceFornecedor === '1' ? 'S' : 'N',
        alcanceSes: formMain.alcanceSes === '1' ? 'S' : 'N',
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(
        `/api/informessisdaf/`,
        formToSend,
      );
      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/adm/informes/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formMain);
      if (!isFormValid) return;

      const formToSend = {
        ...formMain,
        alcanceDaf: Number(formMain.alcanceDaf),
        statusDisplay: Number(formMain.statusDisplay),
        imagemCard: Number(formMain.imagemCard),
        dataInforme: formMain.dataInforme ? formMain.dataInforme : null,
        alcanceFornecedor: formMain.alcanceFornecedor === '1' ? 'S' : 'N',
        alcanceSes: formMain.alcanceSes === '1' ? 'S' : 'N',
      };

      const response = await httpClient.patch(
        `/api/informessisdaf/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/informessisdaf/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/maisopcoes/informes');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/adm/informes"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} entity="TB_INFORME_SISAF" id={Number(fichaID)} />

          <BoxConteudo boxTitulo="Dados do Informe">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="250px">
                <SelectInput
                  name="statusDisplay"
                  options={statusDisplay}
                  label="Display"
                  value={formMain.statusDisplay}
                  onChange={handleChange}
                  style={statusDisplayStyle}
                  required={true}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataInforme"
                  label="Data do Informe"
                  value={formMain.dataInforme}
                  id="dataCriacao"
                  onChange={handleChange}
                  type="date"
                  required={true}
                />
              </CustomCol>

              <CustomCol width="300px">
                <SelectInput
                  name="imagemCard"
                  options={imagemCard}
                  label="Imagem do Card"
                  value={formMain.imagemCard}
                  onChange={handleChange}
                />
              </CustomCol>

              <CustomCol width="250px">
                <SelectInput
                  name="alcanceDaf"
                  options={alcanceInforme}
                  label="Alcance DAF"
                  value={formMain.alcanceDaf}
                  onChange={handleChange}
                  required={true}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="alcanceFornecedor"
                  options={alcanceBin}
                  label="Alcance Fornecedor"
                  value={formMain.alcanceFornecedor}
                  onChange={handleChange}
                  style={alcanceFornecedorStyle}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="alcanceSes"
                  options={alcanceBin}
                  label="Alcance SES"
                  value={formMain.alcanceSes}
                  onChange={handleChange}
                  style={alcanceSesStyle}
                />
              </CustomCol>
            </CustomRow>

            {/* Título */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="titulo"
                  label="Título"
                  value={formMain.titulo}
                  id="link"
                  onChange={handleChange}
                  required={true}
                />
              </CustomCol>
            </CustomRow>

            {/* Resumo */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="resumo"
                  label="Resumo"
                  value={formMain.resumo}
                  id="resumo"
                  onChange={handleChange}
                  type="textarea"
                  linhas={2}
                  required={true}
                />
              </CustomCol>
            </CustomRow>

            {/* Descrição */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="descricao"
                  label="Descrição"
                  value={formMain.descricao}
                  id="resumo"
                  onChange={handleChange}
                  type="textarea"
                  linhas={7}
                  required={true}
                />
              </CustomCol>
            </CustomRow>

            {/* Link */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="urlMaisInfor"
                  label="Link Mais Informações"
                  value={formMain.urlMaisInfor}
                  id="link"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formMain.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
